<template>
  <closing-analysis
    :complete-replacement="completeReplacement"
    :delete-compensatory-document="deleteCompensatoryDocument"
    :download-document-by-attachment-id="downloadDocumentByAttachmentId"
    :get-compensatory-approvement-reasons="getCompensatoryApprovementReasons"
    :get-compensatory-document-types="getCompensatoryDocumentTypes"
    :get-compensatory-request-analysis-data="getCompensatoryRequestAnalysisData"
    :get-compensatory-request-replacement-comments-strategies="
      getCompensatoryRequestReplacementCommentsStrategies
    "
    :get-compensatory-request-replacement-strategies="
      getCompensatoryRequestReplacementStrategies
    "
    :get-sys-parameter="getSysParameter"
    :has-permissions="hasPermissions"
    :replacement-document-upload="replacementDocumentUpload"
    :reset-replacement="resetReplacement"
    :submit-closing-analysis="submitClosingAnalysis"
    :update-compensatory-service-balance="updateCompensatoryServiceBalance"
  />
</template>

<script>
import { ClosingAnalysis } from 'compensatory-service';
import {
  submitClosingAnalysis as _submitClosingAnalysis,
  getCompensatoryRequestReplacementStrategies as _getCompensatoryRequestReplacementStrategies,
  replacementDocumentUpload as _replacementDocumentUpload,
  deleteCompensatoryDocument as _deleteCompensatoryDocument,
  completeReplacement as _completeReplacement,
  resetReplacement as _resetReplacement,
  getCompensatoryRequestReplacementCommentsStrategies as _getCompensatoryRequestReplacementCommentsStrategies,
  getCompensatoryDocumentTypes as _getCompensatoryDocumentTypes,
  getCompensatoryRequestAnalysisData as _getCompensatoryRequestAnalysisData,
  getCompensatoryApprovementReasons as _getCompensatoryApprovementReasons,
  updateCompensatoryServiceBalance as _updateCompensatoryServiceBalance,
} from '@/modules/compensatoryService/api';
import peiServices from '@/modules/app/api.js';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';

export default {
  components: {
    ClosingAnalysis,
  },
  methods: {
    updateCompensatoryServiceBalance(params) {
      return _updateCompensatoryServiceBalance(params);
    },
    submitClosingAnalysis(id, data) {
      return _submitClosingAnalysis(id, data);
    },
    hasPermissions(permission) {
      return this.userHasPermissions(permission);
    },
    getCompensatoryApprovementReasons(requestId) {
      return _getCompensatoryApprovementReasons(requestId);
    },
    getCompensatoryRequestAnalysisData(id) {
      return _getCompensatoryRequestAnalysisData(id);
    },
    getCompensatoryRequestReplacementStrategies(replacementId) {
      return _getCompensatoryRequestReplacementStrategies(replacementId);
    },
    getCompensatoryDocumentTypes(requestId) {
      return _getCompensatoryDocumentTypes(requestId);
    },
    replacementDocumentUpload(params) {
      return _replacementDocumentUpload(params);
    },
    deleteCompensatoryDocument(params) {
      return _deleteCompensatoryDocument(params);
    },
    completeReplacement(payload) {
      return _completeReplacement(payload);
    },
    downloadDocumentByAttachmentId(documentId) {
      return peiServices.downloadDocumentByAttachmentId(documentId);
    },
    resetReplacement(replacementId) {
      return _resetReplacement(replacementId);
    },
    getCompensatoryRequestReplacementCommentsStrategies(replacementId) {
      return _getCompensatoryRequestReplacementCommentsStrategies(
        replacementId
      );
    },
    getSysParameter(academicYearId) {
      return _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.CompensatoryIsExceptionAcademicYear,
        ],
        academicYearId: academicYearId,
      });
    },
  },
};
</script>
